import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58e1a202"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-input-button-hover" }

import { toRefs, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'message-input-button',
  props: {
  enableSend: {
    type: Boolean,
    default: true,
  },
  messages: {
    type: Array,
    default: () => [],
  },
  isH5: {
    type: Boolean,
    default: true,
  },
},
  emits: ['sendMessage'],
  setup(__props, { emit: __emit }) {

const props = __props;
const { enableSend } = toRefs(props);
const emits = __emit;
const sendMessage = () => {
  emits('sendMessage');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['message-input-button', __props.isH5 && 'message-input-button-h5'])
  }, [
    (_unref(enableSend))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "message-input-button-cont",
          "data-type": "text",
          onClick: sendMessage,
          disabled: false
        }, [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('TUIChat.按Enter发送，Ctrl+Enter换行')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('发送')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})